import React from 'react';

export default class GriffInput extends React.Component {
    static MAX_COLLAPSED_ITEMS = 8;

    state = {
        open: false,
        value: this.props.value,
        gruppen: this.getGruppen(),
        toggleOpen: false
    };

    getGruppen() {
        const gruppen = _.orderBy(APP.getUsedGriffGruppen(), ['Anzeigereihenfolge'], ['asc']);
        return gruppen.map(gruppe=>({
            ...gruppe,
            toggleOpen: false,
            griffe: _.orderBy(this.props.griffe, ['Anzeigereihenfolge'], ['asc'])
        }));
    }

    clicked(dekor) {
        this.props.setValue(dekor.Artikelnummer, {next:false});
        this.setState({open: !this.props.autoclose, value: dekor.Artikelnummer})
    }

    close() {
        this.props.setValue(this.state.value, {next:true});
        this.setState({open: false})
    }

    bild(product) {
        const bild = product.Bild || "default.png";
        return SETTINGS.wkfgContentBaseUrl + bild;
    }

    render() {        
        return (
            <div className={"griff " + (this.props.hidden?"disappear":"appear")+' '+(this.state.open?'griff-open':'griff-closed')}>
                <div className="griff-input" onClick={() => this.setState({open: !this.state.open})}>
                    <label htmlFor="sample-input-1">{this.props.label}</label>
                    <div className="griff-select">
                        {this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                        {!this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                    </div>
                </div>
                {this.state.open &&
                <React.Fragment>
                    <div className="griff-list">
                    {this.props.griffe.map((griff, index) =>(
                        (index < GriffInput.MAX_COLLAPSED_ITEMS || this.state.toggleOpen) && (
                            <div className="griff-stil" key={index}>
                                <div className="griff-stil-list">
                                    <h4 className="griff-label">
                                        {griff.Name}
                                        <div className="info" onClick={()=>APP.uiHandler.showHelpPopup(griff)}></div>
                                    </h4>
                                    <div
                                        key={griff.Artikelnummer}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-container="body"
                                        id={"korpus-" + griff.Artikelnummer}
                                        className="griff-item dummyproduct stopselect"
                                        data-decor-title={griff.Name}
                                        url={griff.Bild}
                                        style={{
                                            backgroundImage:'url('+this.bild(griff)+')'
                                        }}
                                        title={griff.Name}
                                        onClick={() => this.clicked(griff)}
                                    ></div>
                                </div>
                            </div>
                        )
                    ))}
                    {this.props.griffe.length>GriffInput.MAX_COLLAPSED_ITEMS && (
                        <div className={"griff-collapse"}>
                            <a className="" onClick={() => {
                                this.state.toggleOpen = !this.state.toggleOpen;
                                this.setState(this.state);
                            }}>
                                {I18N(this.state.toggleOpen ? "Weniger" :  "Mehr")}...
                            </a>
                        </div>
                    )}
                    </div>
                </React.Fragment>
                }
            </div>
        )
    }

}
